module.exports = __webpack_public_path__ + "static/media/weapons.a5d3574c.svg";